import { getRatio, getDetail, aggregateExport, updateFile } from '@/services/locationFrequency';
import { siteTypeCode, transformArray, getDate } from '../../enum';
import { message } from 'antd';

export default {
  namespace: 'lineLocationFrequency',
  state: {
    auth: {},
    searchParams: {
      ofDate: getDate(),
      operationSiteType: 1
    },
    //基准日期，根据ofDate在查询时变动
    baseDate: getDate(),
    // 干线折线图
    ratioData: [],
    // 干线详情
    dataSource: [],
    // 干线导出
    exportData: [],
    // 干线默认展开行
    expandedRowKeys: [],
  },

  effects: {
    *getRatio(_, { call, put, select }) {
      let { searchParams, auth } = yield select(({ lineLocationFrequency }) => lineLocationFrequency);
      // 如果是营运区权限必填
      if (auth.isArea && !searchParams.organizationName) {
        message.warn('请选择组织名称');
        return;
      }
      const params = {
        // ...searchParams,
        ofDate: searchParams.ofDate,
        productType: searchParams.productType,
        lineType: 1,
        organizationCode: searchParams?.organizationName?.code,
        operationSiteType: searchParams.operationSiteType || "",
        organizationType:
          (searchParams?.organizationName?.siteTypeCode &&
            siteTypeCode[searchParams?.organizationName?.siteTypeCode]) ||
          1,
      };
      const { code, data } = yield call(getRatio, params);
      if (code === 1) {
        const dataSource = transformArray(data || []);
        yield put({
          type: 'update',
          payload: {
            ratioData: dataSource,
          },
        });
      }
    },
    *getDetail(_, { call, put, select }) {
      let { searchParams, baseDate, auth } = yield select(({ lineLocationFrequency }) => lineLocationFrequency);
      // 如果是营运区权限必填
      if (auth.isArea && !searchParams.organizationName) {
        return;
      }
      const params = {
        // ...searchParams,
        ofDate: searchParams.ofDate,
        productType: searchParams.productType,
        lineType: 1,
        organizationCode: searchParams?.organizationName?.code,
        operationSiteType: searchParams.operationSiteType || "",
        organizationType:
          (searchParams?.organizationName?.siteTypeCode &&
            siteTypeCode[searchParams?.organizationName?.siteTypeCode]) ||
          1,
      };
      const { code, data } = yield call(getDetail, params);
      if (code === 1) {
        const { firstLevelAggregate = [], secondLevelAggregate = [] } = data;
        const datas = [];
        let exportDatas = [];
        firstLevelAggregate.forEach(item => {
          const obj = secondLevelAggregate[item.code] || [];
          const itemsObj = item.type === '2' ? { ...item, children: obj } : item;
          datas.push(itemsObj);
          exportDatas.push(item);
        });
        Object.values(secondLevelAggregate).forEach(item => {
          if (item && item.length > 0) {
            item.forEach(value => {
              exportDatas.push(value);
            });
          }
        });
        yield put({
          type: 'update',
          payload: {
            dataSource: datas,
            exportData: exportDatas,
            // 营运区默认把行展开
            expandedRowKeys:
              searchParams?.organizationName?.siteTypeCode === '900800'
                ? firstLevelAggregate.map(item => item.code)
                : [],
          },
        });
        yield put({
          type: 'update',
          payload: { baseDate: searchParams.ofDate }
        });
      }
    },
    *export({ payload }, { call, put, select }) {
      let { searchParams, auth } = yield select(({ lineLocationFrequency }) => lineLocationFrequency);
      console.log("查询参数", searchParams);
      // 如果是营运区权限必填
      if (auth.isArea && !searchParams.organizationName) {
        return;
      }
      const params = {
        // ...searchParams,
        ofDate: searchParams.ofDate,
        productType: searchParams.productType,
        lineType: 1,
        organizationCode: searchParams?.organizationName?.code,
        operationSiteType: searchParams.operationSiteType || "",
        organizationType:
          (searchParams?.organizationName?.siteTypeCode &&
            siteTypeCode[searchParams?.organizationName?.siteTypeCode]) ||
          1,
      };
      delete params.organizationName;
      const result = yield call(aggregateExport, params);
      if (result && result.code === 1) {
        message.success('导出成功');
      }
    },
    *updateFile({ payload }, { call, put, select }) {
      let { searchParams, auth } = yield select(({ lineLocationFrequency }) => lineLocationFrequency);
      const formData = new FormData();
      console.log("路径",payload.fileName+".xlsx");
      formData.append('file', payload.sheet2blob, payload.fileName+".xlsx");
      formData.append('pageName', payload.pageName);
      // delete params.organizationName;
      const result = yield call(updateFile, formData);
      if (result && result.code === 1) {
        message.success('导出成功');
      }
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },
  },
};


// 使用fetch上传文件
const uploadFile = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await fetch('/api/blame/aggregate/pageFileToUep', {
      method: 'POST',
      body: formData,
    });
    if (response.ok) {
      console.log('File uploaded successfully');
    } else {
      console.error('Upload failed');
    }
  } catch (error) {
    console.error('Error:', error);
  }
};